import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: '[appNumericInput]' })
export class NumericInputDirective {
	constructor(private el: ElementRef) {}

	@HostListener('input', ['$event']) onInput(event: Event): void {
		const input = event.target as HTMLInputElement;
		const value = input.value;
		input.value = value.replace(/[^\d\n]/g, ''); // Allow only digits and newline
	}
}
